import { ColumnDef } from '@tanstack/react-table'
import { DateComponent } from 'app/components/DateComponent'

export const fileColumns: (fileHandler: (fileSelected: any) => void) => ColumnDef<any, any>[] = (fileHandler) => [
  {
    id: `name`,
    header: `Name`,
    enableHiding: false,
    meta: {
      pinned: true,
      defaultVisible: true,
      sortKey: `name.keyword`,
    },
    accessorFn: (row) => row.fileName,
    cell: (props) => (
      <button className="hover:font-bold hover:underline" onClick={() => fileHandler(props.row.original)}>
        {props.getValue()}
      </button>
    ),
  },
  {
    id: `importDate`,
    header: `Import date`,
    accessorKey: `createdDate`,
    accessorFn: (row) => row.createdDate,
    cell: (props) => <DateComponent value={props.getValue()} dateOnly />,
    meta: {
      defaultVisible: true,
      sortKey: `createdDate`,
    },
  },
  {
    id: `activities`,
    header: `Activities`,
    accessorFn: (row) => row.importIds?.length ?? 0,
    meta: {
      defaultVisible: true,
    },
  },
]
